module.exports = __webpack_public_path__ + "static/img/album02_2.a9fc981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album02/album02_2.png
// module id = /A5c
// module chunks = 1